import { getAnalytics, logEvent, Analytics } from 'firebase/analytics';
import { app } from '../services/firebase';

const analytics: Analytics = getAnalytics(app);

type LogParams = Record<string, any>;

const Logger = {
  info: (message: string, params: LogParams = {}): void => {
    // console.info('[INFO]:', message, params);
    logEvent(analytics, 'info_log', { message, ...params });
  },

  warn: (message: string, params: LogParams = {}): void => {
    // console.warn('[WARN]:', message, params);
    logEvent(analytics, 'warn_log', { message, ...params });
  },

  error: (message: string, params: LogParams = {}): void => {
    // console.error('[ERROR]:', message, params);
    logEvent(analytics, 'error_log', { message, ...params });
  },

  custom: (eventName: string, params: LogParams = {}): void => {
    // console.log(`[CUSTOM EVENT]: ${eventName}`, params);
    logEvent(analytics, eventName, params);
  },
};

export default Logger;
